/** Placeholder workspace returned for unauthenticated callers — treat as missing. */
export const PLACEHOLDER_WORKSPACE_ID = '36443';

/**
 * Resolve workspace id for an active contact (voice/chat/direct connect init).
 * Unauthenticated callers and the placeholder workspace are treated as having no workspace.
 */
export function resolveContactWorkSpaceID(
  workspaceId: string | number | null | undefined,
  authenticated?: boolean
): string | null {
  // if (authenticated !== true) return null;
  if (workspaceId == null || workspaceId === '') return null;
  console.log('workspaceId', workspaceId);
  console.log('authenticated', authenticated);
  // if (String(workspaceId) === PLACEHOLDER_WORKSPACE_ID) return null;
  return String(workspaceId);
}

export function normalizeContactInitWorkspace<
  T extends { workspaceId?: string; authenticated?: boolean },
>(init: T): T {
  const workSpaceID = resolveContactWorkSpaceID(
    init.workspaceId,
    init.authenticated
  );
  return {
    ...init,
    workspaceId: workSpaceID ?? undefined,
  };
}
